export default "__VITE_ASSET__CYNXiyfg__"